export default __webpack_public_path__ + "static/media/fundraiseCollect.8e2728c6.png";